<!-- SMALL SCREEN NAVBAR -->
<div class="container-fluid nav-container mobile-nav">
    <div class="row nav">
        <div class="col-9 mb-nav-left">
            <img src="assets/company-logos/CompanyLogo.png" height="50" alt="Old Faithful Plumbing">
        </div>
        <div class="col-3 mb-nav-right">
            <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
                <span><img class="mb-navbar-icon" src="../assets/site-theme/mb-navbar-icon.svg" alt="Navbar Icon"></span>
            </button>
        </div>
    </div>
    <!--<div class="nav-oval"></div>
    <a rel="#" class="navbar-brand nav-logo">
        <img src="assets/company-logos/CompanyLogo.png" height="100" alt="Old Faithful Plumbing">
    </a>-->
    <div class="collapse navbar-collapse" id="navbarCollapse">
        <div class="navbar-nav mx-auto" data-toggle="collapse" data-target="#navbarCollapse">
            <a routerLink="/" href="/" class="nav-item nav-link active">HOME</a>
        </div>
        <hr>
        <div class="navbar-nav mx-auto" data-toggle="collapse" data-target="#navbarCollapse">
            <a routerLink="/services" href="/services" class="nav-item nav-link active">SERVICES</a>
        </div>
        <hr>
        <div class="navbar-nav mx-auto" data-toggle="collapse" data-target="#navbarCollapse">
            <a routerLink="/contact" href="/contact" class="nav-item nav-link active">CONTACT</a>
        </div>
    </div>
</div>

<!-- LARGE SCREEN NAVBAR -->
<div class="container-fluid nav-container full-nav">
    <div class="row nav">
        <div class="col-3">&nbsp;</div>
        <div class="col-3 home-link">
            <a routerLink="/" href="/">HOME</a>
        </div>
        <div class="col-3 services-link">
            <a routerLink="/services" href="/services">SERVICES</a>
            <!--
                <ul>
                    <li><a routerLink="/" href="/">One</a></li>
                    <li><a routerLink="/" href="/">Two</a></li>
                    <li><a routerLink="/" href="/">Three</a></li>
                </ul>
            -->
        </div>
        <div class="col-3 contact-link">
            <button type="button" class="btn btn-nav"><a class="contact-link-btn" routerLink="/contact" href="/contact">CONTACT</a></button>
        </div>
    </div>
    <div class="nav-oval"></div>
    <a rel="#" class="navbar-brand nav-logo">
        <img src="assets/company-logos/CompanyLogo.png" height="100" alt="Old Faithful Plumbing">
    </a>
</div>


<router-outlet></router-outlet>

<!--FOOTER-->
<footer>
    <picture class="footer-image">
        <source srcset="../assets/site-theme/footer-trees.png">
        <!--<source media="(min-width: 320px)" srcset="../assets/site-theme/footer-trees.png">-->
        <img class="full-width-footer" src="../assets/site-theme/footer-trees.png" alt="Fir Tree Silhouette">
    </picture>
    <div class="container-fluid bg-blue-dark">
        <div class="row text-beige">
            <div class="col-md-6">
                <div class="content-left p-5">
                    <div class="text-center">
                        <img src="assets/company-logos/CompanyLogo.png" height="60" alt="Old Faithful Plumbing">
                        <p class="pt-3">Phone: 587-568-1541</p>
                        <p class="pt-2">Email: oldfaithfulplumbing@gmail.com</p>
                        <div class="footer-icons pt-3">
                            <a href="https://www.facebook.com/profile.php?id=61567152825239" class="rounded-circle sm-circle social-media-icons">
                                <picture>
                                    <source srcset="../assets/site-theme/FacebookIcon.svg">
                                    <img class="social-media-icon" src="../assets/site-theme/FacebookIcon.svg" alt="Facebook Icon">
                                </picture>
                            </a>
                            <!-- they do not have twitter
                            <a href="https://x.com/oldfaithfulplumbing" class="rounded-circle sm-circle social-media-icons">
                                <picture>
                                    <source srcset="../assets/site-theme/TwitterXIcon.svg">
                                    <img class="social-media-icon" src="../assets/site-theme/TwitterXIcon.svg" alt="Twitter X Icon">
                                </picture>
                            </a>
                            -->
                            <a href="https://www.instagram.com/oldfaithfulplumbing/" class="rounded-circle sm-circle social-media-icons">
                                <picture>
                                    <source srcset="../assets/site-theme/InstagramIcon.svg">
                                    <img class="social-media-icon" src="../assets/site-theme/InstagramIcon.svg" alt="Instagram Icon">
                                </picture>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="content-right">
                    <ul class="footer-links text-center p-5">
                        <li><a routerLink="/services" href="/services">Renovation / Remodeling</a></li>
                        <hr>
                        <li><a routerLink="/services" href="/services">Drain Cleaning</a></li>
                        <hr>
                        <li><a routerLink="/services" href="/services">Leak Repair</a></li>
                        <hr>
                        <li><a routerLink="/services" href="/services">Hot Water Tank Replacement</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-purple">
        <p class="text-center text-small pt-2 pb-2">Powered by <a href="">Wired Programming</a></p>
    </div>
</footer>